module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0102.jpg?v=4eeae53f";